import apiArk2 from "@/api/ApiV2"

export default {
  accountFinder(request) {
    return apiArk2.post("accounts/account_finder", request)
  },
}
